<template>
    <div class="mt-8 pb-2 border-b border-a-brown-d7c7b8">
        <Checkbox ref="check-marketing" v-model:check="checkMarketing" @update:check="onCheckChange()">
            <div class="text-16 text-a-brown-502314">{{lbl.profile.i_interested}}</div>
        </Checkbox>
    </div>
</template>
<script>
import Checkbox from '@/components/Input/simple/Checkbox.vue'
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA';

//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    mixins: [LocaleMixin],
    components: {
        Checkbox,
    },
    props: {
        profile: { type: Object, required: true },
    },
    data: function () {
        return {
            checkMarketing: false,

            marketingAccept: 0,
            marketingVersion: 1,
        };
    },
    created: function () {
        this.getConsentVersion();
        this.getUserConsent();
    },
    methods: {
        getUserConsent: function () {
            BzbsPDPA.apiGetConsent().subscribe({
                next: (data) => {
                    if (data.MarketingOption != 0) {
                        this.marketingAccept = data.MarketingOption;
                        this.checkMarketing = true;
                    } else {
                        this.marketingAccept = 0;
                        this.checkMarketing = false;
                    }

                    this.setCheckbox();
                },
                error: (err) => {
                    console.log(err);
                },
            })
        },
        getConsentVersion: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe({
                next: (data) => {
                    this.marketingVersion = data?.marketingOption?.current_version ?? 0;
                },
                error: (err) => {
                    console.log(err);
                },
            })
        },

        setCheckbox: function () {
            this.$refs['check-marketing'].setCheck(this.checkMarketing);
        },

        onCheckChange: function () {
            if (this.checkMarketing) {
                this.marketingAccept = this.marketingVersion;
            } else {
                this.marketingAccept = 0;
            }
        },

        getValue: function () {
            return this.marketingAccept;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
